import { Dropdown } from "primereact/dropdown";
import { AutoComplete } from "primereact/autocomplete";
import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Message } from "primereact/message";
import { Dialog } from "primereact/dialog";
// import infoIcon from '../../../assets/images/info_icon.svg'
import {
	faChevronRight,
	faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import trashIcon from "../../../assets/images/delete_icon_red.png";
import {
	getPivotWeight,
	getULDTypeByCode,
} from "../../../services/searchPanelServices";
import ULDTypeAutocomplete from "../../ULDTypeAutocomplete";
import "./item-form.scss";
import { allowNumberOnly } from "../../../utils/common";
import { useTranslation } from "react-i18next";
import MESSAGES from "../../../constants/Messages";
// import { RadioButton } from 'primereact/radiobutton';

import { deleteAviPetAttachment } from "../../../services/aviBookingService";
import infoicon from "../../../../src/assets/images/infoicon.png";
import pdf from "../../../../src/assets/images/pdf.png";
import excel from "../../../../src/assets/images/excel.png";
import word from "../../../../src/assets/images/word.png";
import walpaper from "../../../../src/assets/images/walpaper.png";
import document from "../../../../src/assets/images/document.png";
import plusIcon from '../../../assets/images/plusBlue.svg';
import { NUMERIC_REGEX } from "../../../../src/constants/regex";
import "./item-form.scss";

import closeIcon from "../../../assets/images/icon-close-alert.png";
import {
	AUTOCOMPLETE_TYPE,
	DIMENSION_UNIT,
	FORM_FIELDS,
	FRESH_FORWARD_PRODUCT,
	getInitLooseItemDetail,
	getInitPharmaObject,
	getInitULDItemDetail,
	PHARMA_PRODUCT,
	PHARMA_SHIPPING_TYPE,
	IS_KNOWN_UNKNOWN,
	PRICE_CODE_TYPE,
	SCC_CODES,
	SHIPPING_TYPE,
	VALIDATE_BOOKINGS_ERROR_CODES,
	WEIGHT_UNIT,
	NOTIFICATION_MESSAGE_TYPE,
	SYSTEM_ADDED_SCCS,
	PAGE_PRIMARY_CATEGORY,
	PAGE_SUB_CATEGORY1,
	getInitPetDetail,
	WEIGHT_UNIT_SELECT_ITEMS,
	DIMENSION_UNIT_SELECT_ITEMS,
} from "../../../constants";
import { SHIPPING_ITEM_PLACEHOLDER } from "../../../constants/Placeholders";
import PetDocUpload from "./PetDocUpload";
import ShippingItemValidationPopUp from "../ShippingItemValidationPopUp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { validateFieldValue } from "../../SearchPanel/formUtils";

import {
	clearItemFromSessionStorage,
	getBase64Decoded,
	getBase64Encoded,
	getFromSessionStorage,
	setToSessionStorage,
	getFromLocalStorage,
	setToLocalStorage,
} from "../../../utils/StorageUtils";

import ConfirmationPopUp from "../../../common/ConfirmationPopUp";
import CommonInput from "../../../common/Resusable/CommonInput";
import { CustomPopup } from "../../../common/Popup/CustomPopup";
import { Divider } from "../../../common/Divider";

const MultiplePetItem = ({
	getToastSuccess,
	getToastError,
	// item,
	// index,
	removedRowCount,
	petList,
	setPetList,
	//handleItemChange,
	AlertProps,
	shippingItem,
	file,
	setFile,
	dogBreeds,
	setArrayListDoc,
	arrayListDoc,
	petOrder,
	stubNose,
	sccWarning,
	cageOrder,
	cageIndex,
	cageList,
	setDeletedPetIds,
	deletedPetIds,
	error,
	setError,
	breedRejected,
	setBreedRejected,
}) => {
	const [breed, setBreed] = useState("");
	const [name, setName] = useState("");
	const [ageInYear, setAgeInYear] = useState("");
	const [ageInMonths, setAgeInMonths] = useState("");
	const [medicalCondition, setMedicalCondition] = useState("");
	// const [petOrder, setPetOrder] = useState(item.petOrder);
	const [petCode, setPetCode] = useState("");
	const [petKey, setPetKey] = useState("");
	const [id, setId] = useState(0);
	const [attachments, setAttachments] = useState([]);
	// const [weight, setWeight] = useState(item.weight)
	// const [uldVolume, setUldVolume] = useState(item.uldVolume)
	// const [pivotWeight, setPivotWeight] = useState(item.pivotWeight)
	//const [sccWarning, setSccWarning] = useState(null)
	const [documentRequired, setDocumentRequired] = useState({});
	// const [weightUnit, setWeightUnit] = useState(item.weightUnit);
	// const [measurement, setMeasurement] = useState('C');
	const [pieces, setPieces] = useState(1);
	const [snubNozedBoolean, setSnubNozedBoolean] = useState(false);
	const [otherBreed, setOtherBreed] = useState("");
	//For multilingual translation
	const { t, i18n } = useTranslation(["labels", "errors"]);
	const { header, setHeader } = useState("Document Required");

	const CONTOUR_ITEMS = [
		{ label: t("BOOKING.MAIN_DECK"), value: "MD" },
		{ label: t("BOOKING.LOWER_DECK"), value: "LD" },
	];

	const [displayUploadSection, setDisplayUploadSection] = useState(false);
	const [fileList, setFileList] = useState([]);
	const [fileName, setFileName] = useState("");
	const [filteredBreeds, setFilteredBreeds] = useState([...dogBreeds]);
	const [text, setText] = useState("");

	// useEffect(() => {
	// 	setAttachments(petList[index].attachments)
	// }, [index])

	// useEffect(() => {
	// 	handleItemChange(0, {
	// 		breed,
	// 		name,
	// 		ageInYear,
	// 		ageInMonths,
	// 		medicalCondition,
	// 		petOrder,
	// 		petCode,
	// 		petKey,
	// 		id,
	// 		stubNose,
	// 		pieces,
	// 		cageOrder,
	// 		attachments,
	// 	})
	// }, [
	// 	breed,
	// 	name,
	// 	ageInYear,
	// 	ageInMonths,
	// 	medicalCondition,
	// 	petOrder,
	// 	petCode,
	// 	petKey,
	// 	id,
	// 	stubNose,
	// 	pieces,
	// 	attachments,
	// ])

	const myRef = React.createRef();

	useEffect(() => {
		// let data = dogBreeds.filter((item) => item.breedCode === breed)
		// if (data.length > 0 && data[0].snubNosed === "Y") {
		// 	setSnubNozedBoolean(true)
		// }
		// else {
		// 	setSnubNozedBoolean(false)
		// }
		// if ((data.length > 0) && (data[0].eyEmbargo === "Y")) {
		// 	setBreedRejected(true)
		// }
		// else {
		// 	setBreedRejected(false)
		// }
	}, [breed]);

	const isSnubNozed = (breed) => {
		if (breed.snubNosed === "Y") {
			return MESSAGES.SNUB_NOSED;
		} else {
			return null;
		}
	};

	const isEyEmbargoRestricted = (breed) => {
		if (breed.eyEmbargo === "Y") {
			return MESSAGES.PET_EYEMBARGO_ERROR_MSG;
		} else {
			return null;
		}
	};

	const handleItemChange = (key, value, index) => {
		const cageListJson = getFromSessionStorage("cageList");
		let tempPetDetails;
		let petDocs = [...petList];

		if (cageListJson) {
			const cageListData = JSON.parse(cageListJson);
			if (
				cageListData[cageIndex].pets &&
				cageListData[cageIndex].pets.length > 0
			) {
				tempPetDetails = [...cageListData[cageIndex].pets];
			}
		}
		tempPetDetails[index][key] = value;
		setPetList([...tempPetDetails], cageIndex);
	};

	const handleAttachment = (petOrder, res, attachments) => {
		let attachmentArrayList = [...attachments, res];
		handleItemChange("attachments", attachmentArrayList, petOrder);
	};

	const clearError = (key, index) => {
		const tempError = error ? { ...error } : null;
		if (
			tempError &&
			tempError[FORM_FIELDS.CAGE_ITEMS] &&
			tempError[FORM_FIELDS.CAGE_ITEMS][index]
		) {
			tempError[FORM_FIELDS.CAGE_ITEMS][index][key] = null;
			setError(tempError);
		}
	};

	const handleError = (key, errorMsg, index) => {
		const tempError = error ? { ...error } : {};
		let cageErrors = error && error[FORM_FIELDS.CAGE_ITEMS];
		if (!cageErrors) {
			cageErrors = [];
			cageErrors[cageIndex] = cageErrors[cageIndex]
				? cageErrors[cageIndex]
				: { [FORM_FIELDS.PETS]: [] };
		}
		if (cageErrors) {
			if (!cageErrors[cageIndex]) {
				cageErrors[cageIndex] = cageErrors[cageIndex]
					? cageErrors[cageIndex]
					: { [FORM_FIELDS.PETS]: [] };
			}

			let errorObjPetsList =
				error &&
					cageErrors[cageIndex] &&
					cageErrors[cageIndex][FORM_FIELDS.PETS]
					? cageErrors[cageIndex][FORM_FIELDS.PETS]
					: null;
			if (!errorObjPetsList) {
				errorObjPetsList = [];
				errorObjPetsList[0] = { [FORM_FIELDS.BREED]: [] };
			}

			const errorObjPets =
				errorObjPetsList && errorObjPetsList[index]
					? errorObjPetsList[index]
					: {};

			errorObjPets[key] = errorMsg;

			errorObjPetsList[index] = errorObjPets;
			cageErrors[cageIndex][FORM_FIELDS.PETS] = errorObjPetsList;
			setError({ ...error, [FORM_FIELDS.CAGE_ITEMS]: cageErrors });
		}
	};

	useEffect(() => {
		setFilteredBreeds([...dogBreeds]);
	}, []);

	useEffect(() => {
		setFilteredBreeds([...dogBreeds]);
	}, [dogBreeds]);

	const searchBreeds = (event) => {
		let text = event.query;
		if (text.length > 2) {
			let breedsByNameStart;
			breedsByNameStart =
				dogBreeds && dogBreeds.length && text && text.length
					? [...dogBreeds].filter((breed) => {
						return ` ${breed.breedName.toLowerCase()}`.includes(
							` ${text.toLowerCase()}`
						);
					})
					: [];

			let dropDownValues = breedsByNameStart.map((item) => item);
			setFilteredBreeds([...dropDownValues]);
		} else {
			setFilteredBreeds([...dogBreeds]);
		}
	};

	const closeDialog = () => {
		setDisplayInfo(false);
	};

	useEffect(() => {
		listArray?.map((element) => {
			setArrayListDoc([...arrayListDoc, element]);
		});
	}, [file]);

	const listArray = [...file];
	// useEffect(() => {
	// 	listArray?.map((element) => {
	// 		setArrayListDoc([...arrayListDoc, element])
	// 	})

	// }, [file])

	// useEffect(() => {
	// 	console.log(docUploadIndex,'docUploadIndex')
	// },[docUploadIndex])

	const customClose = (
		<i>
			<img src={closeIcon} alt="close" title="close" onClick={closeDialog} />
		</i>
	);

	const setDropDownFileList = (list) => {
		setFileList(list);
	};

	const handelDocRequired = (event) => {
		setDocumentRequired((prevState) => ({
			...prevState,
			[documentRequired.id]: true,
		}));
	};

	const handleAddLineItem = (e, petIndex, cageIndex) => {
		e.preventDefault();
		const cageListJson = getFromSessionStorage("cageList");
		if (cageListJson) {
			const cageListData = JSON.parse(cageListJson);
			let petData = [...cageListData[cageIndex].pets, getInitPetDetail()];
			petData[petIndex + 1].petOrder = petIndex + 1;
			//petData[petIndex + 1].cageOrder = cageIndex
			const filteredPetData = petData.map((item) => {
				item.cageOrder = cageIndex;
				return item;
			});
			setPetList(filteredPetData, cageIndex);
		}
	};

	const handleRemoveItem = (indexNum, item) => {
		if (item.id) {
			let idObj = {
				id: item.id,
			};
			setDeletedPetIds([...deletedPetIds, idObj]);
		}
		const itemsTemp = petList.filter((itemDetail, curr) => {
			return item.id ? indexNum !== itemDetail.id : indexNum !== curr;
		});
		// const docdelete = arrayListDoc.filter((itemDetail, curr) => {

		// 	return index !== curr
		// })
		//setArrayListDoc([docdelete])

		setPetList([...itemsTemp], cageIndex);
	};

	const handleRemovepet = (element, ind, petIndex) => {
		const data = {
			attachmentId: element.attachmentId,
			fileName: element.fileName,
		};

		deleteAviPetAttachment(data).then((res) => {
			try {
				if (res === true) {
					// setLoading(false);
					//call toaster
					// getToastSuccess("File Deleted");
					// myToast.current.show({ ...toastDetails, life: 4000 })
					const itemsTemp = petList[petIndex].attachments.filter(
						(itemDetail, curr) => {
							return ind !== curr;
						}
					);

					//setAttachments([...itemsTemp])
					handleItemChange("attachments", itemsTemp, petIndex);
				}
			} catch (error) {
				//setLoading(false);
				// setFile(null);
				// getToastError("Failed to upload file");
				//console.log("errr", error);
			}
		});

		//handleSummaryChange()
		//setRemovedRowCount(removedRowCount * 1 + 1)
	};

	useEffect(() => {
		setError([FORM_FIELDS.CAGE_ITEMS], null);
		if (shippingItem && shippingItem.key) {
			setPetCode(shippingItem.code);
			setPetKey(shippingItem.key);
		}
	}, [shippingItem]);

	const [displayInfo, setDisplayInfo] = useState(false);

	const handelPopup = () => {
		setDisplayInfo(true);
	};

	const handleSelect = (value) => {
		if (value) {
			setBreed(value.breedName);
		}
	};

	const handlePetValidation = (breed) => {
		const isEmbargoError = isEyEmbargoRestricted(breed);
		const snubNosedError = isSnubNozed(breed);
		return isEmbargoError
			? isEmbargoError
			: snubNosedError
				? snubNosedError
				: null;
	};

	return (
		<>
			{petList.map((item, index) => {
				const errorObjPets =
					error &&
						error[FORM_FIELDS.CAGE_ITEMS] &&
						error[FORM_FIELDS.CAGE_ITEMS][cageIndex] &&
						error[FORM_FIELDS.CAGE_ITEMS][cageIndex][FORM_FIELDS.PETS] &&
						error[FORM_FIELDS.CAGE_ITEMS][cageIndex][FORM_FIELDS.PETS][index]
						? error[FORM_FIELDS.CAGE_ITEMS][cageIndex][FORM_FIELDS.PETS][index]
						: null;
				const breedError =
					errorObjPets && errorObjPets[FORM_FIELDS.BREED]
						? errorObjPets[FORM_FIELDS.BREED]
						: null;
				const ageInYearError =
					errorObjPets &&
						errorObjPets[FORM_FIELDS.AGE_YEARS] &&
						errorObjPets[FORM_FIELDS.AGE_MONTHS]
						? errorObjPets[FORM_FIELDS.AGE_YEARS]
						: null;
				const ageInMonthsError =
					errorObjPets &&
						errorObjPets[FORM_FIELDS.AGE_MONTHS] &&
						errorObjPets[FORM_FIELDS.AGE_YEARS]
						? errorObjPets[FORM_FIELDS.AGE_MONTHS]
						: null;
				return (
					<>
						<div className="pet-details-section">
							<div className="pet-details-header">
								<label className="pet-style-label">{`${t("COMMON.PET_HEADING", {
									index: index + 1,
								})}`}</label>
								{petList.length > 1 ? (
									<div className="delete-section" onClick={() =>
										handleRemoveItem(item.id ? item.id : index, item)
									}>
										<img
											src={trashIcon}
											alt="Trash"
											title="Trash"
										/>
										<span>{t("BOOKING.REMOVE_PET")}</span>
									</div>
								) : (
									<></>
								)}
							</div>
							<div className="pet-details-body">
								<div className={`pet-details`}>
									<div className="pet-det-block">
										<div
											className={`form-group common-autocomplete breed-name ${breedError ? "red-border" : ""
												}`}
										>
											<div className="p-float-label input-wrapper">
												<AutoComplete
													id="autocomplete-breedlist"
													name="breedName"
													field="breedName"
													dropdown
													completeMethod={searchBreeds}
													ref={myRef}
													minLength={1}
													suggestions={filteredBreeds}
													value={item.breed ? item.breed : text}
													onChange={(e) => {
														setText(e.target.value);
														//setBreed(null)
														handleItemChange("breed", null, index);
													}}
													onSelect={(e) => {
														//let errorObj = item.error ? item.error : {}
														setText("");
														//handleSelect(e.value)
														setBreed(e.value.breedName);
														handleItemChange("breed", e.value.breedName, index);
														handleItemChange("otherBreed", null, index);
														handleItemChange("snubNosed", e.value.snubNosed, index);

														if (item?.error) {
															item.error.snubNosed = isSnubNozed(e.value);
														} else {
															item.error = {};
															item.error.snubNosed = isSnubNozed(e.value);
														}
														handleItemChange("error", item.error, index);
														handleError(
															[FORM_FIELDS.BREED],
															isSnubNozed(e.value),
															index
														);
													}}
													onFocus={(e) => {
														let errorObj = item.error ? item.error : {};
														errorObj.breed = null;
														handleItemChange("error", errorObj, index);
														if (!errorObj.snubNosed) {
															handleError(
																[FORM_FIELDS.BREED],
																errorObj.breed,
																index
															);
														}
													}}
													onBlur={(e) => {
														let errorObj = item.error;
														errorObj.breed = validateFieldValue(
															e.target.value,
															t(MESSAGES.VALID_BREED)
														);
														handleItemChange("error", errorObj, index);
														if (!errorObj.snubNosed) {
															handleError(
																[FORM_FIELDS.BREED],
																errorObj.breed,
																index
															);
														}
													}}
													className={
														"form-control autocomplete shipping-itm-autocomplete"
													}
												/>
												<label htmlFor={"autocomplete-breedlist"} className="breed-label">
													{t("COMMON.SELECT_BREED_LABEL")}
												</label>
											</div>
											<span className="search-panel__errormsg">
												{breedError ? t(breedError, { ns: "errors" }) : ""}
											</span>
										</div>
										{item.breed === "Other" ? (
											<>
												<div className={`form-group `}>
													<CommonInput
														type="text"
														label={t("COMMON.OTHER_LABEL")}
														value={item.otherBreed ? item.otherBreed : ""}
														onChange={(e) => {
															let value = e.target.value;
															setOtherBreed(e.target.value);
															handleItemChange("otherBreed", value, index);
														}}
														onFocus={(e) => {
															let errorObj = item.error ? item.error : {};
															errorObj.otherBreed = null;
															handleItemChange("error", errorObj, index);
														}}
														onBlur={(e) => {
															let errorObj = item.error ? item.error : {};
															errorObj.otherBreed = validateFieldValue(
																e.target.value,
																t(MESSAGES.VALID_OTHER_BREED)
															);
															handleItemChange("error", errorObj, index);
														}}
														error={
															breedError ? t(breedError, { ns: "errors" }) : ""
														}
													/>
												</div>
												<div className="form-group ">
													<CommonInput
														label={t("COMMON.NAME_LABEL")}
														type="text"
														value={item.name}
														onChange={(e) => {
															setName(e.target.value);
															let value = e.target.value;
															handleItemChange("name", value, index);
														}}
													/>
												</div>

												<div className="form-group ">
													<CommonInput
														type="text"
														label={`${t("COMMON.AGE")}(${t("COMMON.YEARS")})`}
														value={item.ageInYear <= 0 ? "" : item.ageInYear}
														onKeyDown={(evt) => allowNumberOnly(evt)}
														onChange={(e) => {
															const value = e.target.value.replace(/[^0-9.]/g, "");
															if (value.length <= 2 && value >= 0 && value <= 99) {
																let value = Number(e.target.value);
																setAgeInYear(Number(e.target.value));
																handleItemChange("ageInYear", value, index);
															}
														}}
														className="form-control"
														maxLength="7"
														onFocus={(e) => {
															let errorObj = item.error ? item.error : {};
															errorObj.ageInYears = null;
															if (Number(item.ageInMonths) > 0) {
																errorObj.ageInMonths = null;
															}
															handleItemChange("error", errorObj, index);
															handleError(
																[FORM_FIELDS.AGE_YEARS],
																errorObj.ageInYears,
																index
															);
															handleError(
																[FORM_FIELDS.AGE_MONTHS],
																errorObj.ageInMonths,
																index
															);
														}}
														onBlur={(e) => {
															let errorObj = item.error ? item.error : {};
															errorObj.ageInYears =
																item.ageInMonths === 0 ||
																	item.ageInMonths === "" ||
																	!item.ageInMonths
																	? validateFieldValue(
																		e.target.value,
																		MESSAGES.VALID_YEARS
																	)
																	: null;
															if (item.ageInMonths > 0 || item.ageInYear > 0) {
																errorObj.ageInMonths = null;
															}
															handleItemChange("error", errorObj, index);
															handleError(
																[FORM_FIELDS.AGE_YEARS],
																errorObj.ageInYears,
																index
															);
															handleError(
																[FORM_FIELDS.AGE_MONTHS],
																errorObj.ageInMonths,
																index
															);
														}}
														error={
															ageInYearError
																? t(ageInYearError, { ns: "errors" })
																: ""
														}
													/>
												</div>
											</>
										) : (
											<>
												<div className="form-group ">
													<CommonInput
														label={t("COMMON.NAME_LABEL")}
														type="text"
														value={item.name}
														onChange={(e) => {
															setName(e.target.value);
															let value = e.target.value;
															handleItemChange("name", value, index);
														}}
													/>
												</div>
												<div className="form-group ">
													<CommonInput
														type="text"
														label={`${t("COMMON.AGE")}(${t("COMMON.YEARS")})`}
														value={item.ageInYear <= 0 ? "" : item.ageInYear}
														onKeyDown={(evt) => allowNumberOnly(evt)}
														onChange={(e) => {
															const value = e.target.value.replace(/[^0-9.]/g, "");
															if (value.length <= 2 && value >= 0 && value <= 99) {
																let value = Number(e.target.value);
																setAgeInYear(Number(e.target.value));
																handleItemChange("ageInYear", value, index);
															}
														}}
														className="form-control"
														maxLength="7"
														onFocus={(e) => {
															let errorObj = item.error ? item.error : {};
															errorObj.ageInYears = null;
															if (Number(item.ageInMonths) > 0) {
																errorObj.ageInMonths = null;
															}
															handleItemChange("error", errorObj, index);
															handleError(
																[FORM_FIELDS.AGE_YEARS],
																errorObj.ageInYears,
																index
															);
															handleError(
																[FORM_FIELDS.AGE_MONTHS],
																errorObj.ageInMonths,
																index
															);
														}}
														onBlur={(e) => {
															let errorObj = item.error ? item.error : {};
															errorObj.ageInYears =
																item.ageInMonths === 0 ||
																	item.ageInMonths === "" ||
																	!item.ageInMonths
																	? validateFieldValue(
																		e.target.value,
																		MESSAGES.VALID_YEARS
																	)
																	: null;
															if (item.ageInMonths > 0 || item.ageInYear > 0) {
																errorObj.ageInMonths = null;
															}
															handleItemChange("error", errorObj, index);
															handleError(
																[FORM_FIELDS.AGE_YEARS],
																errorObj.ageInYears,
																index
															);
															handleError(
																[FORM_FIELDS.AGE_MONTHS],
																errorObj.ageInMonths,
																index
															);
														}}
														error={
															ageInYearError
																? t(ageInYearError, { ns: "errors" })
																: ""
														}
													/>
												</div>

												<div className="form-group ">
													<CommonInput
														type="text"
														label={`${t("COMMON.AGE")}(${t("COMMON.MONTHS")})`}
														value={item.ageInMonths <= 0 ? "" : item.ageInMonths}
														onKeyDown={(evt) => allowNumberOnly(evt)}
														onChange={(e) => {
															const value = e.target.value.replace(/[^0-9.]/g, "");
															if (value.length <= 2 && value >= 0 && value <= 12) {
																//let value= Number(e.target.value)
																setAgeInMonths(Number(value));
																handleItemChange(
																	"ageInMonths",
																	Number(value),
																	index
																);
															}
														}}
														maxLength="2"
														onFocus={(e) => {
															let errorObj = item.error ? item.error : {};
															errorObj.ageInMonths = null;
															if (item.ageInYear > 0) {
																errorObj.ageInYears = null;
															}
															handleItemChange("error", errorObj, index);
															handleError(
																[FORM_FIELDS.AGE_YEARS],
																errorObj.ageInYears,
																index
															);
															handleError(
																[FORM_FIELDS.AGE_MONTHS],
																errorObj.ageInMonths,
																index
															);
														}}
														onBlur={(e) => {
															let errorObj = item.error ? item.error : {};
															errorObj.ageInMonths =
																item.ageInYear === 0 ||
																	item.ageInYear === "" ||
																	!item.ageInYear
																	? validateFieldValue(
																		e.target.value,
																		MESSAGES.VALID_MONTHS
																	)
																	: null;
															if (item.ageInMonths > 0 || item.ageInYear > 0) {
																errorObj.ageInYears = null;
															}
															handleItemChange("error", errorObj, index);
															handleError(
																[FORM_FIELDS.AGE_YEARS],
																errorObj.ageInYears,
																index
															);
															handleError(
																[FORM_FIELDS.AGE_MONTHS],
																errorObj.ageInMonths,
																index
															);
														}}
														error={
															ageInMonthsError
																? t(ageInMonthsError, { ns: "errors" })
																: ""
														}
													/>
												</div>
											</>
										)}
									</div>
									<div className="pet-det-block mb-3">
										{item.breed === "Other" ? (
											<div className="form-group ">
												<CommonInput
													type="text"
													label={`${t("COMMON.AGE")}(${t("COMMON.MONTHS")})`}
													value={item.ageInMonths <= 0 ? "" : item.ageInMonths}
													onKeyDown={(evt) => allowNumberOnly(evt)}
													onChange={(e) => {
														const value = e.target.value.replace(/[^0-9.]/g, "");
														if (value.length <= 2 && value >= 0 && value <= 12) {
															//let value= Number(e.target.value)
															setAgeInMonths(Number(value));
															handleItemChange("ageInMonths", Number(value), index);
														}
													}}
													maxLength="2"
													onFocus={(e) => {
														let errorObj = item.error ? item.error : {};
														errorObj.ageInMonths = null;
														if (item.ageInYear > 0) {
															errorObj.ageInYears = null;
														}
														handleItemChange("error", errorObj, index);
														handleError(
															[FORM_FIELDS.AGE_YEARS],
															errorObj.ageInYears,
															index
														);
														handleError(
															[FORM_FIELDS.AGE_MONTHS],
															errorObj.ageInMonths,
															index
														);
													}}
													onBlur={(e) => {
														let errorObj = item.error ? item.error : {};
														errorObj.ageInMonths =
															item.ageInYear === 0 ||
																item.ageInYear === "" ||
																!item.ageInYear
																? validateFieldValue(
																	e.target.value,
																	MESSAGES.VALID_MONTHS
																)
																: null;
														if (item.ageInMonths > 0 || item.ageInYear > 0) {
															errorObj.ageInYears = null;
														}
														handleItemChange("error", errorObj, index);
														handleError(
															[FORM_FIELDS.AGE_YEARS],
															errorObj.ageInYears,
															index
														);
														handleError(
															[FORM_FIELDS.AGE_MONTHS],
															errorObj.ageInMonths,
															index
														);
													}}
													error={
														ageInMonthsError
															? t(ageInMonthsError, { ns: "errors" })
															: ""
													}
												/>
											</div>
										) : (
											<></>
										)}
										<div className="form-group special-instr">
											<CommonInput
												type="text"
												label={t("COMMON.SPECIAL_INSTRUCTION")}
												onChange={(e) => {
													let value = e.target.value;
													setMedicalCondition(value);
													handleItemChange("medicalCondition", value, index);
												}}
												maxLength="256"
												rows="1"
												value={item.medicalCondition}
											/>
										</div>
									</div>
								</div>
								<div className="dg-upload-body w-100">
									<div className="upload-doc-label-info">
										<label className="upload-doc-label">
											{petList[index].attachments.length !== 0
												? t("COMMON.FILES_UPLOADED_TEXT")
												: t("COMMON.UPLOAD_ALL_DOC_TEXT")}
										</label>
										<img
											src={infoicon}
											onClick={handelPopup}
											alt="Allowed list"
											title="Allowed list"
											className="upload-doc-icon"
										/>
									</div>

									{displayInfo ? (

										<CustomPopup
											isVisible={displayInfo}
											footerPriBtnLabel={t('COMMON.OK')}
											footerPriBtnClick={closeDialog}
											onClose={closeDialog}
											headerComponent={{ mainHeader: t("COMMON.DOC_REQUIRED") }}
											body={
												<ul className='ml-4' style={{ listStyle: 'disc' }}>
													<li>
														{t("PET_DOCS_INFO.LINE_1")}
													</li>
													<li>
														{t("PET_DOCS_INFO.LINE_2")}
													</li>
													<li>{t("PET_DOCS_INFO.LINE_3")}</li>
													<li>{t("PET_DOCS_INFO.LINE_4")}</li>
													<li>
														{t("PET_DOCS_INFO.LINE_5")}
													</li>
													<li>
														{t("PET_DOCS_INFO.LINE_6")}
													</li>
													<li>{t("PET_DOCS_INFO.LINE_7")}</li>
													<li>
														{t("PET_DOCS_INFO.LINE_8")}
													</li>
													<li>
														{t("PET_DOCS_INFO.LINE_9")}
													</li>
												</ul>
											}
										/>
									) : (
										<></>
									)}


									{petList?.at(index)?.attachments?.length !== 0 && <ul className='dg-up-file-list'>
										{petList[index]?.attachments?.map((item, i) => {
											const filArraypath = item?.fileName?.split(".");
											return (

												<li className="dg-up-file">
													<div className="up-file-details" key={item.petOrder}>
														<img
															src={
																filArraypath && filArraypath[1] === "pdf"
																	? pdf
																	: filArraypath[1] === "xls" ||
																		filArraypath[1] === "xlsx"
																		? excel
																		: filArraypath[1] === "docx"
																			? word
																			: filArraypath[1] === "png" ||
																				filArraypath[1] === "jpeg"
																				? walpaper
																				: document
															}
															alt={filArraypath[1]}
															title={filArraypath[1]}
														/>
														<span> {item.fileName}</span>
													</div>
													<span className='up-file-delete' onClick={(e) => handleRemovepet(item, i, index)}>
														{t("COMMON.DELETE")}
													</span>

												</li>

											);
										})}
									</ul>}
									<PetDocUpload
										setDisplayUploadSection={setDisplayUploadSection}
										setDropDownFileList={setDropDownFileList}
										fileList={fileList}
										// setListPageOpen={setListPageOpen}
										setFileName={setFileName}
										setFileList={setFileList}
										fileName={fileName}
										index={index}
										file={file}
										setFile={setFile}
										fileCount={arrayListDoc[index] ? true : false}
										// arrayListDoc={arrayListDoc?.length > 0 ? arrayListDoc : []}
										arrayListDoc={arrayListDoc}
										setArrayListDoc={setArrayListDoc}
										// handleFileNameSelect={handleFileNameSelect}
										attachments={attachments}
										setAttachments={setAttachments}
										cageIndex={cageIndex}
										petList={petList}
										cageList={cageList}
										handleAttachment={handleAttachment}
									/>
								</div>
							</div>
						</div>
						{petList.length >= 3 || petList.length - 1 !== index ? (
							<Divider />
						) : (
							<div className="add-more-btn" onClick={(e) => handleAddLineItem(e, index, cageIndex)}>
								<img className='add-more-plus' src={plusIcon} alt='plus' title='add-more-plus' />
								<a className="add-more-link">
									<span>{`${t('COMMON.ADD_ANOTHER_PET')}`}</span>
								</a>
							</div>
						)}
					</>
				);
			})}
		</>
	);
};

export default MultiplePetItem;
